import React from "react";
import styled from "styled-components";
import BlogBox from "../Elements/BlogBox";
import TestimonialSlider from "../Elements/TestimonialSlider";

const stories = [
  ["Why Choose Us!", "Omnicom's competitive advantage lies in our track record of Affordability, Prompt delivery, Flexible payment terms and 99.9% uptime of products and services, as well as reduction in the need to stockpile spares."],
  ["Our Core Values!", "We are guided by our core values which includes; Responsibility, Integrity, Professionalism and Innovation."],
  ["Our Vision!", "We are driven by Our VISION to be a global brand revered for offering world class experential services to the telecommunications industry with state of the art technology that guarantees efficiency in network design, maximum uptime and on-the-spot diagnosis and intervention."],
];

export default function Blog() {
  return (
    <Wrapper id="blog">
      <Stories>
        <div className="container">
          <HeaderInfo>
            <div><p className="section-kicker">The principles behind our work</p><h2 className="font40 extraBold">Our stories</h2></div>
            <p>Performance is more than a deliverable. It is the standard we bring to every partner, project and network.</p>
          </HeaderInfo>
          <StoryGrid>{stories.map(([title, text], index) => <BlogBox key={title} title={title} text={text} index={index + 1} />)}</StoryGrid>
        </div>
      </Stories>
      <Milestones>
        <div className="container">
          <MilestoneHead><div><p className="section-kicker">Delivery at scale</p><h2 className="font40 extraBold">Our milestones</h2></div><p>Experienced people. Proven field execution. Measurable impact across networks.</p></MilestoneHead>
          <TestimonialSlider />
        </div>
      </Milestones>
    </Wrapper>
  );
}

const Wrapper = styled.section`width: 100%;`;
const Stories = styled.div`padding: 110px 0 120px; background: #17152f; @media (max-width: 700px) { padding: 80px 0; }`;
const HeaderInfo = styled.div`
  display: grid; grid-template-columns: 1fr .75fr; gap: 80px; align-items: end; margin-bottom: 46px;
  h2 { color: #fff; } .section-kicker { color: #a8cf45; }
  > p { color: rgba(255,255,255,.58); font-size: .9rem; }
  @media (max-width: 760px) { grid-template-columns: 1fr; gap: 18px; }
`;
const StoryGrid = styled.div`display: grid; grid-template-columns: repeat(3, 1fr); gap: 18px; @media (max-width: 780px) { grid-template-columns: 1fr; }`;
const Milestones = styled.div`padding: 110px 0; background: #f6f8f7; @media (max-width: 700px) { padding: 80px 0; }`;
const MilestoneHead = styled.div`
  display: grid; grid-template-columns: 1fr .7fr; align-items: end; gap: 80px; margin-bottom: 38px;
  h2 { color: #17152f; } > p { color: #626878; font-size: .9rem; }
  @media (max-width: 760px) { grid-template-columns: 1fr; gap: 18px; }
`;
